

export const Footer = () => {
    return (
        <footer className='bg-dark navbar-dark fixed-bottom footer-text'>Made with ❤️ & ☕ in Oakville, ON.
        </footer>
    )
}
